import { Injectable, NgZone } from '@angular/core';
import { FileObject } from '../models'
import { FileApi, MyProgressEvent } from './webservice'
import { Observable, Observer } from 'rxjs/Rx';

export class FileUpload {
	private bytesLoaded: {[key: string]: number} = {}
	private fileSizeSum: number
	private percentLoaded: number
	private observer: Observer<UploadEvent>
	private fileObjects: FileObject[]

	constructor(private fileApi: FileApi) {

	}

	public saveFileObjects(fileObjects: FileObject[]): Observable<UploadEvent> {
		this.fileObjects = fileObjects;
		this.fileSizeSum = this.getFilesizeSum(fileObjects);
		console.log("filesize sum: " + this.getFilesizeSum(fileObjects))
		return Observable.create((observer: Observer<UploadEvent>) => {
			this.observer = observer;
			for (let fileObject of fileObjects){
				if (fileObject.file) {
					this.uploadFileAndMetaData(fileObject)
				} else {
					this.updateMetaData(fileObject)
				}
			}
		})

	}
	private uploadFileAndMetaData(fileObject: FileObject) {
		this.fileApi.uploadFile(fileObject)
			.subscribe(
				(event) => this.handleProgressEvent(event),
				(error) => this.handleErrorEvent(error)
			)
	}

	private updateMetaData(fileObject: FileObject) {
		this.fileApi.updateMetaData(fileObject.metaData.id, fileObject.metaData).subscribe(
			(success) => {
				fileObject.uploadSuccessful = true;
				fileObject.uploadError = null;
				this.checkAndHandleUploadCompletion()
			},
			(error) => {
				fileObject.uploadSuccessful = false;
				fileObject.uploadError = "can't update metadata";
				this.checkAndHandleUploadCompletion()
			}
		)
	}

	private handleProgressEvent(event: MyProgressEvent) {
		if (event.type === "progress") {
			this.bytesLoaded[event.filename] = event.loaded;
			this.updatePercentLoaded();
			this.sendEvent(new UploadEvent(this.percentLoaded, false));
		}
		if (event.type === "readystatechange") {
			let fileObject = this.getFileObject(event.filename)
			fileObject.uploadSuccessful = true;
			fileObject.uploadError = null;
			fileObject.metaData = event.metaData
			this.checkAndHandleUploadCompletion()
		}
	}

	private handleErrorEvent(error) {
		let fileObject = this.getFileObject(error.filename)
		fileObject.uploadError = "can't upload file."
		fileObject.uploadSuccessful = false;
		this.checkAndHandleUploadCompletion()
	}

	private checkAndHandleUploadCompletion() {
		if (this.isUploadComplete()) {
			let uploadEvent = new UploadEvent(this.percentLoaded, true);
			uploadEvent.fileObjects = this.fileObjects;
			this.sendEvent(uploadEvent);
		} else {
			this.sendEvent(new UploadEvent(this.percentLoaded, false));
		}
	}
	private isUploadComplete() {
		for (let fileObject of this.fileObjects){
			if (!fileObject.uploadSuccessful && !fileObject.uploadError) {
				return false
			}
		}
		return true;
	}

	private getFileObject(filename: string): FileObject {
		for (let file of this.fileObjects) {
			if (file.uniqueFilename === filename) {
				return file;
			}
		}
	}

	private sendEvent(event: UploadEvent) {
		this.observer.next(event)
	}

	private updatePercentLoaded() {
		let bytesUploaded = this.getBytesUploaded()
		console.log("loaded " + bytesUploaded)
		let rawPercentage = ( bytesUploaded / this.fileSizeSum) * 100;
		console.log("percent: " + rawPercentage)
		let rounded = Math.min(100, Math.round(rawPercentage));
		console.log(rounded)
		this.percentLoaded = rounded;
	}

	private getBytesUploaded(): number {
		let sum = 0;
		for (let key in this.bytesLoaded) {
			sum = sum + this.bytesLoaded[key];
		}
		return sum;
	}

	private getFilesizeSum(files: FileObject[]): number {
		if (files.length === 0) return 0;
		let filteredList = files.filter(fileObject => fileObject.file !== undefined && fileObject.file != null)
		if (filteredList.length === 0) return 0;
		if (filteredList.length === 1) return filteredList[0].file.size
		return filteredList.map(fileObject => fileObject.file.size)
			.reduce((sum, size) => sum + size)
	}
}

export class UploadEvent {
	public fileObjects: FileObject[];
	constructor(public percentLoaded: number, public finished: boolean = false) {
	}
}



// WEBPACK FOOTER //
// ./src/app/services/file-upload.service.ts